import { GraphQLClient } from 'graphql-request';
import { getLocale } from '@locale/index';
import { GraphQLBaseURL } from '@config/api-host';
import { getUserId, getOrgId, getAgentId, removeTokenCookie, getOrgNameFromUrl, getAgentNameFromUrl, getAgentLangFromUrl, getLayerIdFromUrl, getLayerTypeFromUrl } from '@lib/index';

const graphQLClient = new GraphQLClient(GraphQLBaseURL, {
  mode: 'cors',
  headers: {
    'Content-Type': 'application/json'
  }
});

// 数据复杂且内容经常变化的数据采用graphql访问，以拥抱变化
export const request = (query: string, params?: any, resultPath?: string, headers?: any) => {
  const promise = new Promise((resolve, reject) => {

    graphQLClient.setHeader('userID', getUserId());
    graphQLClient.setHeader('orgID', getOrgId() || '');
    graphQLClient.setHeader('agentID', getAgentId() || '');
    graphQLClient.setHeader('locale', getLocale().localeStr);
    graphQLClient.setHeader('orgName', getOrgNameFromUrl() || '');
    graphQLClient.setHeader('agentName', getAgentNameFromUrl() || '');
    graphQLClient.setHeader('agentLang', getAgentLangFromUrl() || '');
    graphQLClient.setHeader('layerID', getLayerIdFromUrl() || '');
    graphQLClient.setHeader('layerType', getLayerTypeFromUrl() || '');

    graphQLClient.setHeader('Accept', 'application/json');

    if (headers) {
      for (const [k, v] of Object.entries(headers)) {
        graphQLClient.setHeader(k, v as string);
      }
    }

    graphQLClient.rawRequest(query, params)
      .then((res: any) => {
        if (res.status === 200) {

          if (resultPath) {
            const paths = resultPath.split('.');

            let ret = res.data;
            for (const path of paths) {
              ret = ret[path];
            }
            resolve(ret);
          } else if (res.data.list) {
            resolve(res.data.list);
          } else if (res.data.result) {
            resolve(res.data.result);
          } else {
            resolve(res.data);
          }

        } else {
          reject(res.message);
        }
      })
      .catch((res: any) => {
        if (res.response && res.response.status === 401) {
          removeTokenCookie();
          if (window.location.pathname.endsWith('copilot')) {
            window.location.href = '/copilot_login';
          } else {
            window.location.href = '/login';
          }
          reject(new Error(res.response && res.response.msg));
        } else if (res.response && res.response.errors) {

          if (res.response.status === 200 && res.response.errors[0].message.includes('empty result') && res.response.data !== null && res.response.data !== undefined) {
            console.log('ingore empty result error of graphql request', res.response.errors);
            if (resultPath) {
              const paths = resultPath.split('.');

              let ret = res.response.data;
              for (const path of paths) {
                ret = ret[path];
              }
              resolve(ret);
            } else if (res.response.data.list) {
              resolve(res.response.data.list);
            } else if (res.response.data.result) {
              resolve(res.response.data.result);
            } else {
              resolve(res.response.data);
            }

            return;
          }
          const message = res.response.errors.map((err: any) => err.message).join('\n');
          reject(new Error(message));
        } else if (res.response && res.response.msg) {
          reject(new Error(res.response && res.response.msg));
        } else {
          reject(new Error('unknown error!'));
        }
      });
  });

  return promise;
};
